import { Injectable } from '@angular/core';
import {map} from 'rxjs/operators';
import {Store} from '../store';
import {ApiService} from '../services/api.service';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SnippetService {
    env = environment;

    constructor(
        private http: HttpClient,
        private apiService: ApiService,
        private store: Store,
    ) { }

    getByRoute(route) {
        return this.http.get(this.env.apiPath + 'cms/admin/page/snippets/' + route, this.apiService.getHttpOptions())
            .pipe(map((data: any) => {
            return data;
        }));
    }

    saveSortation(snippets) {
        const dataToSend = {
            snippets,
        };
        return this.http.post(this.env.apiPath + 'cms/admin/page/snippets/sort', dataToSend, this.apiService.getHttpOptions())
            .pipe(map((data: any) => {
            return data;
        }));
    }

    createSnippet(page, snippet) {
        const dataToSend = {
            snippet,
            page
        };
        return this.http.post(this.env.apiPath + 'cms/admin/page/snippets/create', dataToSend, this.apiService.getHttpOptions())
            .pipe(map((data: any) => {
            return data;
        }));
    }

    saveSnippet(snippet) {
        const dataToSend = {
            snippet,
        };
        return this.http.post(this.env.apiPath + 'cms/admin/page/snippets/update', dataToSend, this.apiService.getHttpOptions())
            .pipe(map((data: any) => {
            return data;
        }));
    }

    deleteSnippet(snippet) {
        const dataToSend = {
            snippet
        };
        return this.http.post(this.env.apiPath + 'cms/admin/page/snippets/delete', dataToSend, this.apiService.getHttpOptions())
            .pipe(map((data: any) => {
            return data;
        }));
    }
    getPlugins() {
        return this.http.get(this.env.apiPath + 'cms/admin/plugins', this.apiService.getHttpOptions())
            .pipe(map((data: any) => {
            return data;
        }));
    }
}
